const {cancelRequest} = require('./notification.catalogue');

const fillNotification = ({notification = {}, keys = {}, status = {}} = {}) => ({
    ...notification,
    keys: {
        headerTitle: keys.cancelNotificationTitle,
        ctaText: keys.cancelNotificationButtonText,
        statusLabel: keys.cancelNotificationStep,
    },
    status,
});

class NotificationFactory {
    create({keys = {}, status = {}, ctaHandler = null, id} = {}) {
        return fillNotification({
            notification: cancelRequest({ctaHandler, id}),
            keys: keys,
            status,
        });
    }
}

module.exports = new NotificationFactory();
